import React from 'react';

import { ReactComponent as IconNumberEight } from 'media/svg/numberEight.svg';
import { ReactComponent as IconNumberFive } from 'media/svg/numberFive.svg';
import { ReactComponent as IconNumberFour } from 'media/svg/numberFour.svg';
import { ReactComponent as IconNumberNine } from 'media/svg/numberNine.svg';
import { ReactComponent as IconNumberOne } from 'media/svg/numberOne.svg';
import { ReactComponent as IconNumberSeven } from 'media/svg/numberSeven.svg';
import { ReactComponent as IconNumberSix } from 'media/svg/numberSix.svg';
import { ReactComponent as IconNumberThree } from 'media/svg/numberThree.svg';
import { ReactComponent as IconNumberTwo } from 'media/svg/numberTwo.svg';
import { ReactComponent as IconNumberZero } from 'media/svg/numberZero.svg';

export enum LoyaltyValue {
    NumberZero = '0',
    NumberOne = '1',
    NumberTwo = '2',
    NumberThree = '3',
    NumberFour = '4',
    NumberFive = '5',
    NumberSix = '6',
    NumberSeven = '7',
    NumberEight = '8',
    NumberNine = '9',
}

const Icon: React.FC<{ value: LoyaltyValue }> = ({ value }) => {
    switch (value) {
        case LoyaltyValue.NumberZero:
            return <IconNumberZero />;
        case LoyaltyValue.NumberOne:
            return <IconNumberOne />;
        case LoyaltyValue.NumberTwo:
            return <IconNumberTwo />;
        case LoyaltyValue.NumberThree:
            return <IconNumberThree />;
        case LoyaltyValue.NumberFour:
            return <IconNumberFour />;
        case LoyaltyValue.NumberFive:
            return <IconNumberFive />;
        case LoyaltyValue.NumberSix:
            return <IconNumberSix />;
        case LoyaltyValue.NumberSeven:
            return <IconNumberSeven />;
        case LoyaltyValue.NumberEight:
            return <IconNumberEight />;
        case LoyaltyValue.NumberNine:
            return <IconNumberNine />;
        default:
            return null;
    }
};

export default Icon;
